import { useState, type ChangeEvent, type FormEvent } from "react";

const JBCountModal = (props: any) => {
  const [bidderCount, setBidderCount] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateBidderCount = (value: string) => {
    if (!value.trim()) {
      return "Number of bidders is required";
    }

    const numValue = Number(value);
    if (isNaN(numValue)) {
      return "Please enter a valid number";
    }

    if (!Number.isInteger(numValue)) {
      return "Please enter a whole number";
    }

    if (numValue < 2) {
      return "Number of bidders must be at least 2";
    }

    if (numValue > 1000) {
      return "Number of bidders cannot exceed 1000";
    }

    return "";
  };

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setBidderCount(value);

    // Clear error when user starts typing
    if (error) {
      setError("");
    }
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    const validationError = validateBidderCount(bidderCount);
    if (validationError) {
      setError(validationError);
      return;
    }

    setIsSubmitting(true);

    try {
      // Call the onSubmit prop with the bidder count
      if (props.onSubmit) {
        await props.onSubmit(Number(bidderCount));
      }

      // Redirect to the specified URL
      if (props.redirectUrl) {
        window.location.href = props.redirectUrl;
      }
    } catch (error) {
      setError("An error occurred. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    if (props.onCancel) {
      props.onCancel();
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-30">
      <div className="bg-white shadow-2xl rounded-xl w-full max-w-lg">
        <form
          onSubmit={handleSubmit}
          className="w-full flex flex-col items-center px-4 py-6 border bg-[#FCFFFB] border-brand-bgGrey rounded-lg"
        >
          <div className="flex items-center space-x-3">
            <div>
              <p className="font-openSans text-[22px] font-semibold text-brand-bgBlack text-center">
                Enter Number of Bidders
              </p>
              <p className="font-openSans text-[16px] text-gray-700 text-center mt-1">
                Please specify the number of joint bidders for this event.
              </p>
            </div>
          </div>

          <div className="w-full mt-6">
            <div className="mb-4">
              <input
                type="number"
                id="bidderCount"
                value={bidderCount}
                onChange={handleInputChange}
                className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-0 focus:border-gray-400 ${
                  error ? "border-red-500" : "border-gray-300"
                }`}
                placeholder="Enter number of bidders"
                min="2"
                max="1000"
                step="1"
                disabled={isSubmitting}
              />
              {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
            </div>
          </div>

          <div className="w-full mt-6 flex space-x-4">
            <button
              type="submit"
              disabled={isSubmitting || !bidderCount.trim()}
              className="bg-black hover:bg-black text-white px-6 py-2 rounded-lg w-full disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
            <button
              type="button"
              disabled={isSubmitting}
              className="bg-gray-300 text-black hover:bg-gray-400 px-6 py-2 rounded-lg w-full disabled:opacity-50"
              onClick={handleCancel}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default JBCountModal;
